import revive_payload_client_4sVQNw7RlN from "/opt/buildhome/repo/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import components_plugin_KR1HBZs4kY from "/opt/buildhome/repo/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "/opt/buildhome/repo/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import prefetch_client_5tzzN0oIVL from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import colors_P6HToJYIMH from "/opt/buildhome/repo/node_modules/@nuxthq/ui/dist/runtime/plugins/colors.mjs";
import plugin_client_i8AMfKeYnY from "/opt/buildhome/repo/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.mjs";
import chunk_reload_client_UciE0i6zes from "/opt/buildhome/repo/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import maska_UHaKf2z1iQ from "/opt/buildhome/repo/plugins/maska.ts";
import sentry_client_shVUlIjFLk from "/opt/buildhome/repo/plugins/sentry.client.ts";
import trpcClient_M8UiGTyzsx from "/opt/buildhome/repo/plugins/trpcClient.ts";
import vueUniqueId_Hq9hDiMPRL from "/opt/buildhome/repo/plugins/vueUniqueId.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  prefetch_client_5tzzN0oIVL,
  colors_P6HToJYIMH,
  plugin_client_i8AMfKeYnY,
  chunk_reload_client_UciE0i6zes,
  maska_UHaKf2z1iQ,
  sentry_client_shVUlIjFLk,
  trpcClient_M8UiGTyzsx,
  vueUniqueId_Hq9hDiMPRL
]